module.exports = __webpack_public_path__ + "img/liked.67e421b3.svg";